import { Swiper, SwiperSlide } from 'swiper/react';
import { Image } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css'; // Swiper styles
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import 'swiper/swiper-bundle.css';
import 'swiper/css/pagination';


function ImageSliderContent({ dataObj }) {
    return (
        <Swiper
            modules={[Navigation, Autoplay, Pagination]}
            spaceBetween={20}
            slidesPerView={dataObj.home_no_items ? dataObj.home_no_items : "1.5"}
            navigation={(dataObj.home_slider_hide_arrow)==1?false:true}
            pagination={dataObj.home_slider_hide_dots ? false : { clickable: true }}
            loop={"true"}
            speed={3000} // Transition speed in ms
            autoplay={{
                delay: 3500, // 1.5 seconds
                disableOnInteraction: false,
            }}

        >
            {dataObj.gallery_items.map((value) => {
                return (
                    <SwiperSlide>
                        <div className='joyful_item'>
                            <Image src={value.home_gallery_image_url} />
                            <h6>{value.home_gallery_caption_text}</h6>
                            <p>{value.home_gallery_description}</p>
                            <Link to={value.home_gallery_image_link != "" ? value.home_gallery_image_link : "#"}>{value.home_gallery_link_text} <i className="bi bi-arrow-right-short"></i></Link>
                        </div>
                    </SwiperSlide>
                )
            })}
        </Swiper>
    )
}

export default ImageSliderContent